import BubbleMedicoOnline from './BubbleMedicoOnline';

export default BubbleMedicoOnline